module.exports = __webpack_public_path__ + "static/media/ipad_11_inch_pro_space_grey.98265162.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_11_inch_pro_space_grey.jpeg
// module id = 2101
// module chunks = 0